import ArrowLink from "@/components/ui/arrow-link";
import ActualCard from "@/components/entities/news-card";
import { useTranslations } from "next-intl";
import { useHomeData } from "../../hooks/useHomeData";
import ActualCardLoading from "@/components/entities/news-card/loading-card";
import { Container } from "@/components/ui/container";
import { Swiper, SwiperSlide } from "swiper/react";
import S from "./index.module.scss";

const NewsSection = () => {
  const t = useTranslations();
  const { actual, loadingActual } = useHomeData();

  if (!actual || !actual?.articles?.length) return null;

  return (
    <Container className={S.wrapper}>
      <h2 className={S.title}>{t("news")}</h2>
      <div className={S.newsList}>
        <Swiper
          slidesPerView={3}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 8,
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
          }}
        >
          {loadingActual
            ? new Array(3).fill({ id: 0 }).map((_, idx) => <ActualCardLoading key={idx} />)
            : actual.articles?.map(item => (
                <SwiperSlide key={item.id}>
                  <ActualCard actual={item} />
                </SwiperSlide>
              ))}
        </Swiper>
      </div>
      <ArrowLink text={t("seeAll")} url="/actual" />
    </Container>
  );
};

export default NewsSection;
